import React, { useEffect } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import TheLayout from '../../layout/TheLayout';
import FirstView from '../../asset/firstview.png';
import CartItem from './CartItem';
import './style.css';
import ButtonComponent from '../Util/ButtonComponent';

import {
  getCartList,
  getCartListLocal,
  disableFlag,
  mergeCart,
  createCart,
} from '../../redux/actions/cart';

const keywords = ['TERRA', 'cart', 'カート'];

const Cart = () => {
  const history = useHistory();
  const cartsDB = useSelector((state) => state.cart.cartsDB, shallowEqual);
  const cartsLocal = useSelector((state) => state.cart.cartsLocal, shallowEqual);
  const total = useSelector((state) => state.cart.total, shallowEqual);
  const isChangeCart = useSelector((state) => state.cart.isChangeCart, shallowEqual);
  const accessToken = useSelector((state) => state.auth.accessToken, shallowEqual);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn, shallowEqual);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCartListLocal());
  }, [dispatch, isChangeCart]);

  useEffect(() => {
    dispatch(disableFlag());
  }, [cartsLocal, dispatch]);

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(getCartList(accessToken, 1, 0));
    }
  }, [accessToken, dispatch, isLoggedIn]);

  useEffect(() => {
    if (isLoggedIn && cartsDB?.length < 1) {
      dispatch(createCart(accessToken, cartsLocal));
    }
  }, [cartsDB, dispatch, accessToken, cartsLocal, isLoggedIn]);

  useEffect(() => {
    if (cartsDB && cartsDB[0] && cartsDB[0].products) {
      dispatch(mergeCart(cartsDB[0].products, accessToken));
    }
  }, [accessToken, cartsDB, dispatch]);

  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>カート｜株式会社TERRA</title>
      </Helmet>
      <div className="cart">
        <div
          className="first_view d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${FirstView})`,
            backgroundSize: '100% 100%',
            height: '15vh',
            fontSize: '2rem',
            letterSpacing: '1rem',
            color: 'white',
          }}
        >
          カート
        </div>
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>カート</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="cart container">
          <div className="row">
            <div className="col-12 col-lg-8 pb-5 cart-item">
              <div className="cart-list">
                <div className="mb-4 mt-4" style={{ color: '#224B71', borderBottom: '2px solid #224B71' }}>商品の選択</div>
                {
                  cartsLocal.length > 0
                    ? cartsLocal.map((c) => (
                      <CartItem key={c.product_id} product={c} />
                    ))
                    : (
                      <p className="text-center">カート内に商品がありません</p>
                    )
                }
              </div>
            </div>
            <div className="col-12 col-lg-4 pb-5 cart-button">
              <div className="total-price pt-4">
                <p className="text">商品合計（税込）</p>
                <p className="price">{`¥ ${total.toLocaleString()}`}</p>
              </div>
              <div className="pb-3">
                <ButtonComponent
                  background="#224B71"
                  borderColor="#224B71"
                  color="white"
                  disabled={cartsLocal.length <= 0}
                  onClick={() => history.push('/apply?typeLink=signin')}
                >
                  {
                    isLoggedIn ? '購入' : 'ログインして購入'
                  }

                </ButtonComponent>
              </div>
              {
                isLoggedIn ? '' : (
                  <>
                    <div className="pb-3">
                      <ButtonComponent
                        background="white"
                        borderColor="#224B71"
                        color="#224B71"
                        disabled={cartsLocal.length <= 0}
                        onClick={() => history.push('/apply?typeLink=signup')}
                      >
                        会員登録して購入
                      </ButtonComponent>
                    </div>
                    <div className="pb-5">
                      <ButtonComponent
                        background="#E6E6E6"
                        borderColor="#E6E6E6"
                        color="#808080"
                        disabled={cartsLocal.length <= 0}
                        onClick={() => history.push('/apply?typeLink=guest')}
                      >
                        会員登録せずに購入
                      </ButtonComponent>
                    </div>
                  </>
                )
              }

            </div>
          </div>
        </div>
      </div>
    </TheLayout>
  );
};
export default Cart;
